import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import EditDropdown from '@components/EditDropdown';
import Thumbnail from '@components/@core/Thumbnail';
import { LibraryTrainingMenu } from '~/services/config';
import { removeAssign } from '~/services/util';

const Course = ({ userRole, name, modules, tracks, assigned, thumbnail, description, published, coursesCount, onDetail, onSelect }) => {
    const options = removeAssign(LibraryTrainingMenu[userRole], published);
    return (
        <div className="library-course-card p-0">
            <div className="lib-content d-flex ssm-column">
                <div className="d-flex d-flex-1 cursor-pointer" onClick={onDetail}>
                    <Thumbnail source={thumbnail} />
                    <div className="course-content ai-start">
                        <div className="d-flex-5 me-4 cursor-pointer">
                            <p className="dsl-b16 text-400 pb-0 mb-1 text-truncate word-break">{name}</p>
                            <p className="dsl-b16 text-truncate word-break mb-0">{description}</p>
                        </div>
                        <div className="d-flex-1">
                            <p className="dsl-b16 mb-0 text-nowrap count">{tracks || 0}</p>
                        </div>
                        <div className="d-flex-1">
                            <p className="dsl-b16 ms-2 ps-1 mb-0 text-nowrap count">{modules || 0}</p>
                        </div>
                        <div className="d-flex-1">
                            <p className="dsl-b16 ms-3 ps-1 mb-0 text-nowrap count">{assigned || 0}</p>
                        </div>
                    </div>
                    <div className={cx('edit justify-content-end', coursesCount > 2 && 'editDropdownScroll')}>
                        <EditDropdown options={options} onChange={onSelect} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(Course);
